export enum LocationTypeEnum {
  FARM = 'FARM',
  STABLE = 'STABLE',
  FUELSTATION = 'FUEL',
  WEIGHINGSTATION = 'WEIGHING',
  OTHERS = 'OTHERS',
}
